<template>
  <main-header-desktop v-if="!$isMobile"
                       @scrollToTop="scrollToTopBlock"
                       @scrollTo="scrollToBlock"
                       :menu-info="menuInfo"/>
  <main-header-mobile v-else
                      @scrollToTop="scrollToTopBlock"
                      @scrollTo="scrollToBlock"
                      :menu-info="menuInfo"/>
</template>

<script>
import MainHeaderDesktop from "@/components/widgets/MainHeaderDesktop.vue";
import MainHeaderMobile from "@/components/widgets/MainHeaderMobile.vue";

export default {
  name: "MainHeader",
  components: {MainHeaderMobile, MainHeaderDesktop},
  computed: {
    menuInfo() {
      return this.navigationStatic.filter(item => item?.isActiveHeader);
    }
  }
}
</script>

<style scoped lang="scss">
</style>